import * as React from 'react'

import { timestampDate } from '@bufbuild/protobuf/wkt'
import { useNavigate } from '@tanstack/react-router'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { toaster } from '@enechain/ecloud-designsystem'

import { ApiKey } from '~/gen/proto/bff/v1/model_pb'
import { ApiKeyForm } from '~/pages/ApiKeys/components/ApiKeyForm'
import { useUpdateApiKey } from '~/pages/ApiKeys/hooks/useUpdateApiKey'

type Props = {
  apiKey: ApiKey
}

export const EditApiKeyForm: React.FC<Props> = ({ apiKey }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { mutate, isPending } = useUpdateApiKey()

  return (
    <ApiKeyForm
      defaultValues={{
        name: apiKey.name,
        roleNames: apiKey.roleNames,
        expirationType: apiKey.expiresAt ? 'date' : 'noExpiration',
        expiresAt: apiKey.expiresAt
          ? format(timestampDate(apiKey.expiresAt), 'yyyy/MM/dd')
          : '',
      }}
      isSubmitting={isPending}
      summary={{
        title: t('pages.api_keys.edit.summary.title'),
        submitLabel: t('pages.api_keys.edit.summary.submit'),
      }}
      onSubmit={(values) => {
        mutate(
          { id: apiKey.id, ...values },
          {
            onSuccess: () => {
              toaster.create({
                title: t('pages.api_keys.edit.success'),
                type: 'success',
              })
              void navigate({
                to: '/api_keys/$apiKeyId',
                params: { apiKeyId: apiKey.id },
              })
            },
            onError: (error) => {
              toaster.create({
                title: error.message,
                type: 'error',
              })
            },
          },
        )
      }}
    />
  )
}
